{
  "version": 1,
  "asset_id": "0976cf8d-e7be-407e-a5cb-d863998e711f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0976cf8d-e7be-407e-a5cb-d863998e711f/loc-georgetown-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0976cf8d-e7be-407e-a5cb-d863998e711f/loc-georgetown-640.webp",
  "original_filename": "loc-georgetown-640.webp",
  "size": 32942,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:27Z"
}
